__turbopack_export_value__({
  "phone": "PhoneLink-module-scss-module__ka5Una__phone",
});
